import React from 'react'
import Link from 'next/link'
import { DEFAULT_IMAGE } from '@/lib/constant'
import { cloudFrontUrl, currencyHelper } from '@/lib/utils'
import { ImageLoader } from '../ui/image-loader'

interface DestinationCardProps {
    title: string
    price: number | undefined | null
    tours: number
    image: string | null
    href: string
}

const TrekDestinationCard = ({ title, price, tours, image, href }: DestinationCardProps) => {
    return (
        <Link href={`/trek-category/${href}`} className='h-64 lg:h-56 xl:h-[17rem] w-full relative rounded-lg overflow-hidden flex justify-end items-end px-2 pb-1 md:p-3 group select-none'>
            <ImageLoader src={image ? cloudFrontUrl(image) : DEFAULT_IMAGE} alt='destination img' fill className='object-cover' />
            <div className='h-full w-full bg-black/25 absolute top-0 left-0' />
            <div className='relative h-fit w-full text-white flex flex-col gap-1 lg:translate-y-4 lg:group-hover:translate-y-0 duration-500 ease-in-out'>
                <h3 className='text-base lg:text-lg font-lexend font-medium md:font-semibold text-nowrap overflow-hidden text-ellipsis'>
                    {title}
                </h3>
                <span className='h-0.5 w-full lg:w-[3.75rem] bg-white scale-y-[0.6] group-hover:w-full duration-500 ease-out' />
                <div className='text-xs flex flex-col md:flex-row md:items-center flex-nowrap md:gap-2 lg:opacity-0 group-hover:opacity-100 duration-500 transition-all ease-in-out'>
                    <p>
                        {price && price > 0 ? `Starting Price ₹${currencyHelper(price)}/-` : "Price on Request"}
                    </p>
                    <span className='w-0.5 h-3 bg-white scale-x-50 shrink-0 hidden md:block' />
                    <p>
                        {tours} {tours > 1 ? "Treks" : "Trek"}
                    </p>
                </div>
            </div>
        </Link>
    )
}

export default TrekDestinationCard